import MainBlock from './MainBlock';

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Trans } from 'react-i18next';

function SatelliteSchool() {
  const { schoolName } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, ["load"]);



  return(
      <>
      <div className='sateliteSchoolMainLayoutBlock'>
        <MainBlock />
      </div>
        
      </>
  )
}

export default SatelliteSchool;